import {
  ActiveStatusRenderer,
  type BaseRate,
} from '@components/Freight/Ratebooks/Drill-in/components/ActiveStatusRenderer'

import type { PointToPoint } from '../../../../../../../api/useFreight/types'
import type { ICellRendererParams } from 'ag-grid-community'
import { useQueryClient } from '@tanstack/react-query'

/**
 * Component for rendering and managing point-to-point active status
 */
export function StatusCell({ data, api, context }: ICellRendererParams<PointToPoint>) {
  const queryClient = useQueryClient()
  if (!data) return null

  return (
    <ActiveStatusRenderer
      value={data.disabled || false}
      data={data as BaseRate}
      rateType='pointToPoint'
      context={context}
      onSuccess={() => queryClient.invalidateQueries({ queryKey: ['ratebook/p2p'] })}
      api={api}
    />
  )
}
